import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { RiskRatingService } from '../tokens/risk-rating.token';
import { Stage7CreditScoreSummary } from '../models/risk-rating.model';
import { API_PATHS } from '../config/api-paths';

/**
 * REST-only implementation of `RiskRatingService` (EM-155 / ST-09).
 *
 * Every method calls the real `/services/embedded/api/risk-rating/...`
 * endpoint via `HttpClient`. Rule 07 + Rule 10 — no mock fallback, no
 * internal in-memory state, no `Mock*` sibling class.
 * Playwright tests intercept the HTTP layer via `page.route()`.
 *
 * ST-10/11 will extend this class with additional methods for KYC/UW decision
 * queue management. The class is intentionally minimal here — add methods
 * alongside the new token interface extensions when those subtasks land.
 */
@Injectable()
export class RiskRatingRestService implements RiskRatingService {
  private readonly http = inject(HttpClient);

  getLatest(applicationId: number): Observable<Stage7CreditScoreSummary> {
    return this.http.get<Stage7CreditScoreSummary>(
      `${API_PATHS.EMBEDDED_API_BASE}/risk-rating/${applicationId}`,
    );
  }
}
